var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddAsset = function SvgAddAsset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 1.2a6.8 6.8 0 1 0 0 13.6 6.8 6.8 0 0 0 0-13.6ZM10 6a.6.6 0 0 1 .6.6v2.8h2.8a.6.6 0 1 1 0 1.2h-2.8v2.8a.6.6 0 1 1-1.2 0v-2.8H6.6a.6.6 0 1 1 0-1.2h2.8V6.6A.6.6 0 0 1 10 6Z",
    fill: "#666"
  })));
};
export default SvgAddAsset;